import { useUser, useClerk } from "@clerk/react";
import { Link, useLocation } from "wouter";
import { Menu, X, User, LogOut, LogIn, Star } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export function Navbar() {
  const [location, navigate] = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { signOut } = useClerk();
  const { isSignedIn, isLoaded } = useUser();

  const signedIn = isLoaded && isSignedIn;

  const navLinks = [
    { href: "/tenders", label: "全部招標" },
    { href: "/pricing", label: "定價" },
    { href: "/market", label: "商機無限" },
    { href: "/weeklyexample", label: "每週精選" },
    { href: "/tips", label: "溫馨提示" },
    { href: "/guides", label: "採購指南" },
    { href: "/faq", label: "常見問題" },
  ];

  return (
    <header className="sticky top-0 z-50 w-full border-b backdrop-blur supports-[backdrop-filter]:bg-[#F8F9F5]/90 bg-[#F8F9F5]">
      <div className="container mx-auto flex h-20 items-center justify-between px-4 md:px-8 opacity-[1] font-normal bg-[#00000000]">
        <div className="flex items-center gap-6">
          <Link href="/" className="flex items-center gap-2 transition-opacity hover:opacity-80">
            <img src="/logo-full.webp" alt="Skoltend" className="h-16 object-contain" width="202" height="64" />
          </Link>
          
          <nav className="hidden md:flex gap-6">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  location.startsWith(link.href) ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {signedIn ? (
            <>
              <Link href="/dashboard" className="text-sm font-medium text-muted-foreground hover:text-primary">
                控制台
              </Link>
              <Link href="/favourites" title="我的最愛" className={`flex items-center transition-colors hover:text-primary ${location.startsWith("/favourites") ? "text-primary" : "text-muted-foreground"}`}>
                <Star className="h-5 w-5" />
              </Link>
              <Link href="/profile">
                <Button variant="ghost" size="icon" className="rounded-full cursor-pointer">
                  <User className="h-5 w-5" />
                </Button>
              </Link>
              <Button
                variant="ghost"
                size="sm"
                className="gap-1.5 text-muted-foreground hover:text-foreground"
                onClick={() => signOut(() => navigate("/"))}
              >
                <LogOut className="h-4 w-4" />
                登出
              </Button>
            </>
          ) : (
            <>
              <Link
                href="/sign-in"
                className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground hover:text-primary"
              >
                <LogIn className="h-4 w-4" />登入
              </Link>
              <Link href="/pricing">
                <Button size="sm" className="font-medium">成為會員</Button>
              </Link>
            </>
          )}
        </div>

        <button
          className="md:hidden p-2 text-muted-foreground hover:text-primary"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label={mobileMenuOpen ? "關閉選單" : "開啟選單"}
          aria-expanded={mobileMenuOpen}
          aria-controls="mobile-menu"
        >
          {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div id="mobile-menu" className="md:hidden border-t bg-background px-4 py-4 space-y-4 shadow-lg absolute w-full">
          <nav className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                href={link.href}
                className={`text-sm font-medium transition-colors hover:text-primary ${
                  location.startsWith(link.href) ? "text-primary" : "text-muted-foreground"
                }`}
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}
            {signedIn ? (
              <>
                <div className="h-px bg-border my-2" />
                <Link href="/dashboard" className="text-sm font-medium text-muted-foreground" onClick={() => setMobileMenuOpen(false)}>
                  控制台
                </Link>
                <Link href="/favourites" className="flex items-center gap-1.5 text-sm font-medium text-muted-foreground" onClick={() => setMobileMenuOpen(false)}>
                  <Star className="h-4 w-4" /> 我的最愛
                </Link>
                <Link href="/profile" className="text-sm font-medium text-muted-foreground" onClick={() => setMobileMenuOpen(false)}>
                  個人資料
                </Link>
                <button
                  className="text-sm font-medium text-muted-foreground hover:text-foreground flex items-center gap-1.5 text-left"
                  onClick={() => { setMobileMenuOpen(false); signOut(() => navigate("/")); }}
                >
                  <LogOut className="h-4 w-4" /> 登出
                </button>
              </>
            ) : (
              <>
                <div className="h-px bg-border my-2" />
                <Link
                  href="/sign-in"
                  className="text-sm font-medium text-muted-foreground"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  登入
                </Link>
                <Link href="/pricing" onClick={() => setMobileMenuOpen(false)}>
                  <Button className="w-full mt-2">成為會員</Button>
                </Link>
              </>
            )}
          </nav>
        </div>
      )}
    </header>
  );
}
